// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SLi1a","navigation":"styles_navigation__elKpG","collapsed":"styles_collapsed__avhyJ","project":"styles_project__n0qbX"};